module.exports = __webpack_public_path__ + "static/msps_liability-7e6a5e2d374e0a17be2d18cc2d278a86.svg";